import React, { useRef, useState, useEffect, useCallback } from "react";

import { useSelector, useDispatch } from "react-redux";
import logo from "Assets/postcast-logo.png"; // Tell webpack this JS file uses this image

// import LeaderBoard from "../HamburgerMenu/pages/Default/LeaderBoard";
// import IncorrectGuesses from "../../../ActionPanel/GameDetails/IncorrectGuesses";

// import PerformanceUpdate from "./PerformanceUpdate";
// import Score from "../../../ActionPanel/GameDetails/Score";
import Confetti from "react-confetti";
import LeaderBoard from "../HamburgerMenu/pages/Default/LeaderBoard";
import Stopwatch from "Components/Games/Newsie/UploadContentNewsie/NewsiePreview/NewsieBottomBar/Stopwatch";
import { MODALS } from "../..";
import { setPublicModal } from "Store/features/public/publicStateSlice";
import ShareButton from "Components/ShareButton";

import "./Winner.css";

const Winner = () => {
  const [height, setHeight] = useState(0);
  const [width, setWidth] = useState(0);
  const [left, setLeft] = useState(0);

  const ref = useRef(null);
  const pageContainerRef = useRef(null);
  const dispatch = useDispatch();
  const leaderboard = useSelector((state) => state.publicPuzzleSlice.leaderboard) || [];
  useEffect(() => {
    if (ref.current) {
      setHeight(ref.current.clientHeight + 15);
      setWidth(ref.current.clientWidth);
    }
    if (pageContainerRef.current) {
      console.log(pageContainerRef.current.getBoundingClientRect());
      setLeft(pageContainerRef.current.getBoundingClientRect().left);
    }
  }, [ref.current, pageContainerRef.current]);

  const guessable = useSelector(
    (state) => state.publicPuzzleSlice.puzzle.guessable
  );
  const puzzleType = useSelector((state) => state.publicPuzzleSlice.puzzleType);

  const postcastUser = useSelector((state) => state.publicUserSlice);
  const { username } = postcastUser;

  const timer = useSelector((state) => state.publicPuzzleSlice.timer);

  const incorrectGuesses = useSelector(
    (state) => state.publicPuzzleSlice.incorrectGuesses
  );
  const { time, timer_active } = useSelector((state) =>
    state.publicPuzzleSlice.timer
      ? state.publicPuzzleSlice.timer
      : { time: -1, timer_active: false }
  );
  const SCORE = 1000 - time - 10 * incorrectGuesses;

  const handleClickClaimUsername = useCallback((e) => {
    e.stopPropagation();
    dispatch(setPublicModal(MODALS.CREATE_ACCOUNT));
  });

  return (
    <div ref={pageContainerRef} className="winner-modal">
      <div style={{ width: "100%" }} ref={ref}>
        <div className="confetti-container">
          <Confetti
            width={width}
            height={height}
            opacity={0.4}
            initialVelocityY={5}
            recycle={true}
            gravity={0.05}
          />
        </div>

        <div className="winner-modal-header-text-container">
          <h4>WOO HOO!</h4>
          <h3>{username}</h3>
          <h4>You beat the {puzzleType}!</h4>
        </div>
        <div className="winner-modal-mr-newsie">
          <img src={logo} alt="Logo" />
        </div>
      </div>
      <div className="completed-game-final-details-container">
        <div className="completed-time-container">
          <Stopwatch />
        </div>
        {/* <IncorrectGuesses incorrectGuesses={incorrectGuesses} /> */}
        {/* <Score score={SCORE} /> */}
      </div>
      <div className="username-or-username-cta-container">
        {username ? (
          null
        ) : (
          <div>
            Save your score and compete for high scores!
            <div
              className="set-username-cta"
              onClick={handleClickClaimUsername}
            >
              Set your username! 🏆
            </div>
          </div>
        )}
      </div>

      <div className="title-description-divider" />
      <LeaderBoard
        leaderBoardTitle="Top Scores"
        leaderBoardData={leaderboard}
      />
      <div className="share-button-wrapper">
        <ShareButton
          modal
          gameOver={true}
          guessable={guessable}
          time={timer?.time}
          score={SCORE}
          incorrectGuesses={incorrectGuesses}
        />
      </div>
    </div>
  );
};

export default Winner;
